module.exports = __webpack_public_path__ + "img/pattern3.79b830f.svg";